import { jsx as _jsx } from "preact/compat/jsx-runtime";
/**
 * Instead of coming to the Marketplace and seeing all plans that
 * an applicant is eligible for, a direct enrollment consumer is
 * someone who went directly to an issuer website, applied, and was
 * redirected to the Marketplace for verification services to be run.
 * This message is displayed to those consumers to provide guidance
 * on how to complete their application.
 */
const DeConsumerMessage = props => {
  return /*#__PURE__*/_jsx("div", {
    className: "ds-u-fill--primary-darker ds-base--inverse ds-u-padding-y--2",
    children: /*#__PURE__*/_jsx("div", {
      className: "ds-l-container",
      children: props.t('header.deConsumerMessage', {
        brokerName: props.deBrokerName || props.t('header.deBrokerNameFallback')
      })
    })
  });
};
export default DeConsumerMessage;